<template>
  <div>
    <!-- <validation-observer ref="playerValidation"> -->
    <modal-documentos
      :listDocumentos="playerSelected.archivos_jugador"
      :playerSelected="playerSelected"
    ></modal-documentos>
    <modal-pase
      :listCategorias="listCategorias"
      :listEquiposTransferir="listEquiposTransferir"
      :player="playerSelected"
      @initDataPase="initDePase"
    ></modal-pase>

    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showNewPlayer"
      scrollable
      no-close-on-backdrop
      title="Agregar / Editar Jugador"
      @hidden="resetModal"
      cancel-variant="outline-secondary"
    >
      <!-- {{ playerSelected.dataCategoria }} -->
      <!-- {{ categoriaSeleccionada }} -->
      <!-- {{ campeonatoAbosoluto }} -->
      <b-row>
        <b-col cols="12" md="4">
          <croppa
            v-model="croppaFoto"
            :width="170"
            :height="200"
            placeholder="Subir foto jugador"
            placeholder-color="#543338"
            :placeholder-font-size="16"
            canvas-color="transparent"
            :show-remove-button="disabledObj.foto"
            remove-button-color="black"
            :show-loading="
              $store.state.someVariables.actionPlayer == UPDATE_DATA_PLAYER ||
              $store.state.someVariables.actionPlayer ==
                INSERT_DATA_HISTORY_PLAYER
                ? true
                : false
            "
            :loading-size="50"
            loading-color="#606060"
            :quality="1"
            :initial-image="getProxy(playerSelected.foto_jug)"
          ></croppa>
        </b-col>
        <b-col cols="12" md="5" class="ml-1">
          <croppa
            v-model="croppaCedula"
            :width="290"
            :height="200"
            placeholder="Subir frontal cedula"
            placeholder-color="#543338"
            :placeholder-font-size="16"
            canvas-color="transparent"
            :show-remove-button="disabledObj.foto"
            remove-button-color="black"
            :show-loading="
              $store.state.someVariables.actionPlayer == UPDATE_DATA_PLAYER ||
              $store.state.someVariables.actionPlayer ==
                INSERT_DATA_HISTORY_PLAYER
                ? true
                : false
            "
            :loading-size="50"
            loading-color="#606060"
            :initial-image="getProxy(playerSelected.foto_cedula)"
          ></croppa>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col md="7">
          <v-select
            ref="refCi"
            id="input-ci-pasaporte"
            :options="listPlayers"
            placeholder="C.I / PASAPORTE *"
            outlined
            taggable
            v-model="playerSelected.ci_pasaporte"
            @search="searchPlayer"
            @input="changePlayer"
            :disabled="disabledObj.buscador"
            :clearable="
              $store.state.someVariables.actionPlayer == UPDATE_DATA_PLAYER
                ? false
                : true
            "
          ></v-select>
          <!-- <div class="form-label-group">
            <b-form-input
              id="floating-cedula"
              placeholder="Ingrese Cédula / Pasaporte *"
            />
            <label for="floating-cedula">Cédula / Pasaporte </label>
          </div> -->
        </b-col>
        <b-col md="5">
          <div class="form-label-group">
            <b-form-input
              id="floating-camiseta"
              placeholder="Ingrese # Camiseta *"
              type="number"
              v-model="playerSelected.num_camiseta"
            />
            <label for="floating-camiseta">N Camiseta</label>
          </div>
        </b-col>
        <!-- <b-col md="12" style="margin-top:-12px;">
          <b-form-checkbox
            v-model="isPassportOther"
            value="A"
            :disabled="disabledInputs"
          >
            <p style="font-size:10px;color:gray !important">
              Permitir Pasaporte / Otro documento
            </p>
          </b-form-checkbox>
        </b-col> -->
        <b-col md="12" style="margin-top:10px">
          <div class="form-label-group">
            <b-form-input
              id="floating-nombres"
              placeholder="Ingrese Nombres *"
              :formatter="formatter"
              v-model="playerSelected.nombres"
              :disabled="disabledObj.nombres"
            />
            <label for="floating-nombres">Nombres</label>
          </div>
        </b-col>
        <b-col md="12" style="margin-top:10px">
          <div class="form-label-group">
            <b-form-input
              id="floating-apellidos"
              placeholder="Ingrese Apellidos *"
              :formatter="formatter"
              v-model="playerSelected.apellidos"
              :disabled="disabledObj.apellidos"
            />
            <label for="floating-apellidos">Apellidos</label>
          </div>
        </b-col>
        <b-col md="12" style="margin-top:10px">
          <div class="form-label-group">
            <b-form-input
              id="floating-nacimiento"
              type="date"
              v-model="playerSelected.fecha_nac"
              :disabled="disabledObj.fechaNacimiento"
              @input="calculateAge"
            />
            <label for="floating-nacimiento">Fecha de nacimiento *</label>
          </div>
        </b-col>
        <!-- <b-col md="2" style="margin-top:6px; cursor:pointer">
          <b-popover
            ref="popover"
            target="popover-reactive-1"
            triggers="hover"
            :show.sync="popoverShow"
            placement="top"
            container="my-container"
          >
            <template v-slot:title>
              <div class="d-flex justify-content-between align-items-center">
                <span>Validaciones</span>
              </div>
            </template>
            <div>
              <div
                style="font-size:12px"
                v-for="(item, index) in playerSelected.validations"
                :key="index"
              >
                <b>{{ index + 1 }} - </b> {{ item.mensaje }}
              </div>
            </div>
          </b-popover>
          <b-avatar id="popover-reactive-1" variant="warning">
            <feather-icon icon="InfoIcon" />
          </b-avatar>
        </b-col> -->

        <b-col md="7" style="margin-top:6px">
          <div class="form-label-group">
            <b-form-input
              id="floating-edad"
              placeholder="Edad"
              v-model="playerSelected.edad"
              disabled
            />
            <label for="floating-edad">Edad</label>
          </div>
        </b-col>
        <template
          v-if="
            $store.getters['someVariables/getActionPlayer'] !==
              INSERT_DATA_HISTORY_PLAYER
          "
        >
          <b-col md="5" style="margin-top:6px">
            <div class="form-label-group">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-form-checkbox
                    plain
                    v-model="checkClasificado"
                    name="checkbox-input"
                    v-if="playerSelected.tieneClasificado == 's'"
                  />
                </b-input-group-prepend>
                <b-form-input
                  v-model="playerSelected.tipoJugador"
                  placeholder="Tipo Jugador"
                  disabled
                />
              </b-input-group>
            </div>
          </b-col>
          <b-col md="12">
            <div
              style="background: cornsilk; padding: 7px;border-radius: 10px;"
            >
              <div
                style="text-align: center; font-weight: bold; font-size: 10px;"
              >
                VALIDACIONES
              </div>
              <div
                style="font-size:12px"
                v-for="(item, index) in playerSelected.validations"
                :key="index"
              >
                <b>{{ index + 1 }} - </b> {{ item.mensaje }}
              </div>
            </div>
          </b-col>
          <b-col md="12" style="margin-top:16px">
            <v-select
              id="input-posicion"
              :options="posiciones"
              placeholder="Posición del Jugador"
              dense
              outlined
              v-model="playerSelected.posicion"
            ></v-select>
          </b-col>
          <b-col
            v-if="tiposAdicional.length != 0"
            md="12"
            style="margin-top:15px"
          >
            <v-select
              id="input-tipo-dos"
              :options="tiposAdicional"
              placeholder="Tipo de Jugador(Opc)"
              dense
              outlined
              v-model="playerSelected.tipo_adicional"
            ></v-select>
          </b-col>

          <b-col md="12" style="margin-top:16px">
            <div class="form-label-group">
              <b-form-input
                id="floating-email"
                placeholder="Ingrese Email (Opc)"
                v-model="playerSelected.email"
                :disabled="disabledObj.email"
              />
              <label for="floating-email">Email (Opc)</label>
            </div>
          </b-col>
          <b-col md="12" style="margin-top:6px">
            <div class="form-label-group">
              <b-form-input
                id="floating-direccion"
                placeholder="Ingrese Dirección (Opc)"
                v-model="playerSelected.direccion"
                :disabled="disabledObj.direccion"
              />
              <label for="floating-direccion">Direccion (Opc)</label>
            </div>
          </b-col>
          <b-col md="12" style="margin-top:6px">
            <div class="form-label-group">
              <b-form-input
                id="floating-telefono"
                placeholder="Ingrese telefono (Opc)"
                v-model="playerSelected.telefono"
                :disabled="disabledObj.telefono"
              />
              <label for="floating-telefono">Teléfono (Opc)</label>
            </div>
          </b-col>
          <b-col md="10">
            <b-form-group>
              <b-form-radio-group
                id="btn-radios-1"
                v-model="playerSelected.estado_jug"
                button-variant="outline-primary"
                :options="optionsEstado"
                buttons
                name="radios-btn-default"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="
              (USER().rol === `${ROLES.ADMIN}` ||
                USER().rol === `${ROLES.SUPER}` ||
                USER().rol === `${ROLES.CALIFICACION}`) &&
                playerSelected.estado_jug !== `${ESTADO_JUGADOR.CALIFICADO}`
            "
            md="12"
            class=" mt-0 d-flex justify-content-left"
          >
            <b-form-checkbox
              style="display:block"
              v-model="playerSelected.permiso_editar_personal"
            >
              <span style="font-size:12px"
                >Permitir la edicion de fotos, nombres, apellidos, fecha
                nac</span
              >
            </b-form-checkbox>
          </b-col>
          <b-col md="12" class="mt-1 d-flex justify-content-center">
            <a
              v-if="
                playerSelected.id_jugador != null &&
                  (USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.CALIFICACION)
              "
              @click="showModalPase"
              href="#"
              style="font-size:12px;position: absolute;top: -15px; text-decoration: underline;"
              >Transferir jugador</a
            >
          </b-col>

          <b-col md="12" style="margin-top:6px">
            <div>
              <label for="tags-basic">Observaciones</label>
              <b-form-tags
                :disabled="disabledObservacion"
                input-id="tags-basic"
                class="mb-2"
                placeholder=""
                v-model="playerSelected.observaciones"
                @input="automatizeObservacion"
              />
            </div>
          </b-col>
        </template>
        <template
          v-if="
            (USER().rol === `${ROLES.ADMIN}` ||
              USER().rol === `${ROLES.SUPER}` ||
              USER().rol === `${ROLES.CALIFICACION}`) &&
              playerSelected.dataCategoria.facialWeb &&
              playerSelected.estado_jug === `${ESTADO_JUGADOR.CALIFICADO}`
          "
        >
          <div style="background:#EAEAEC; width:100%; padding:10px">
            <b-col md="12">
              <b-form-file
                v-model="filesFotos"
                placeholder="Fotos para Reconocimiento facial..."
                drop-placeholder="Drop file here..."
                multiple
            /></b-col>
            <b-col class="mt-1 text-center">
              <b-button
                v-if="!showLoadingProcesar"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                size="sm"
                @click="procesarImagenes"
              >
                <span>procesar</span>
              </b-button>
              <div v-if="showLoadingProcesar" class="text-center mt-1">
                <b-spinner variant="primary" label="Text Centered" />
              </div>
            </b-col>
          </div>
        </template>
        <template
          v-if="
            $store.getters['someVariables/getActionPlayer'] ==
              UPDATE_DATA_PLAYER
          "
        >
          <div
            style=" width:100%; text-align: center; font-weight: bold;"
            class="mt-2"
          >
            DOCUMENTOS/PASES/HABILITACIONES..
          </div>
          <div style="background:#EAEAEC; width:100%; padding:10px">
            <b-col md="12">
              <b-form-file
                v-model="filesDocumentos"
                placeholder="Arraste o seleccione el/los documentos .."
                drop-placeholder="Drop file here..."
                multiple
            /></b-col>
            <b-col class="mt-1 text-center">
              <b-button
                v-if="!showLoadingProcesarDocumentos"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                size="sm"
                @click="procesarDocumentos"
              >
                <span>Subir</span>
              </b-button>
              <div v-if="showLoadingProcesar" class="text-center mt-1">
                <b-spinner variant="primary" label="Text Centered" />
              </div>
            </b-col>
            <div
              v-if="
                playerSelected.archivos_jugador &&
                  playerSelected.archivos_jugador.length > 0
              "
              @click="openRespaldos"
              style="text-decoration:underline;font-size:10px;color:gray;cursor:pointer;float:right"
            >
              <span>Ver Documentos</span>
            </div>
          </div>
        </template>
        <b-col
          v-if="
            $store.getters['someVariables/getActionPlayer'] ===
              INSERT_DATA_HISTORY_PLAYER
          "
          md="12"
          style="color:black;background:#ffc107; font-size:11px; padding:10px;border-radius:4px"
        >
          <span
            >Está en el modo <b>“Agregar jugador por cédula”</b>. Si necesita
            actualizar la información de un jugador, primero debe presionar
            <b>AGREGAR</b> y luego editar sus datos desde el listado.</span
          >
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col md="12">
              <div class="d-block">
                <p class="inscrito">
                  Inscrito: {{ playerSelected.fecha_inscripcion }}
                </p>
                <p
                  v-if="
                    playerSelected.estado_jug === `${ESTADO_JUGADOR.CALIFICADO}`
                  "
                  class="calificado"
                >
                  Calificado: {{ playerSelected.fecha_calificacion }} por
                  {{ playerSelected.calificado_por }}
                </p>
                <p
                  v-for="item in playerSelected.historial_calificaciones"
                  :key="item.id"
                  class="recalificado"
                >
                  Recalificado: {{ item.fecha_recalifica }} por
                  {{ item.user_recalifica }}
                </p>
              </div>
            </b-col>

            <b-col class="mt-1">
              <template v-if="!showLoading">
                <b-button
                  v-if="
                    USER().rol === `${ROLES.ADMIN}` ||
                      USER().rol === `${ROLES.SUPER}` ||
                      USER().rol === `${ROLES.CALIFICACION}` ||
                      (USER().rol === `${ROLES.CLUB}` &&
                        categoriaSeleccionada.isOpen &&
                        !categoriaSeleccionada.isInReview &&
                        (playerSelected.estado_jug ==
                          `${ESTADO_JUGADOR.INSCRITO}` ||
                          playerSelected.estado_jug ==
                            `${ESTADO_JUGADOR.REVISADO}`))
                  "
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="float-right"
                  @click="savePlayer"
                >
                  <span>{{ actionPlayer }}</span>
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="float-right mr-1"
                  @click="onlyClose"
                >
                  Cancelar
                </b-button>
              </template>
              <div v-if="showLoading" class="text-center mt-1">
                <b-spinner variant="primary" label="Text Centered" />
              </div>
            </b-col>
          </b-row>
          <b-alert
            :show="dismissCountDown"
            v-height-fade.appear
            :variant="variante"
            style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
            @dismiss-count-down="countDownChanged"
          >
            <div
              :class="{
                'alert-body danger': variante == 'danger',
                'alert-body success': variante == 'success',
              }"
            >
              {{ messageError }}
            </div>
          </b-alert>
        </div>
      </template>
      <!-- <b-button ref="hola" @click="holaMundo">
        aplasta
      </b-button> -->
    </b-modal>
    <!-- </validation-observer> -->
  </div>
</template>
<script>
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import { required, email } from '@validations'
import vSelect from 'vue-select'
import { heightFade } from '@core/directives/animations'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import {
  watch,
  // watchEffect,
  computed,
  // reactive,
  ref,
  // onUpdated,
} from '@vue/composition-api'

// import Cleave from 'vue-cleave-component'
import {
  BModal,
  BRow,
  BCol,
  BFormInput,
  // BFormTextarea,
  BFormGroup,
  BFormRadioGroup,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BAlert,
  BButton,
  BSpinner,
  VBPopover,
  // BAvatar,
  // BPopover,
  BFormTags,
  BFormFile,
  // VBTooltip,
  //   BForm,
  //   BInputGroup,
  //   BInputGroupPrepend,
} from 'bootstrap-vue'

import apiCall from '../../utils/apiCall'
import ModalPase from './PaseModal.vue'
import ModalDocumentos from './ModalDocumentos.vue'

import {
  URL,
  URL_PROXY,
  USER,
  ROLES,
  ESTADO_JUGADOR,
  INSERT_DATA_PLAYER,
  INSERT_DATA_HISTORY_PLAYER,
  UPDATE_DATA_PLAYER,
  URL_PROCESO_IMAGENES,
} from '../../utils/variables'

const moment = require('moment-timezone')

moment.tz.setDefault('America/Guayaquil')

export default {
  components: {
    BModal,
    BRow,
    BCol,
    // vSelect,
    BFormInput,
    // BFormTextarea,
    vSelect,
    // ValidationProvider,
    // ValidationObserver,
    // Cleave,
    BFormGroup,
    BFormRadioGroup,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BAlert,
    BButton,
    BSpinner,
    // BAvatar,
    // BPopover,
    BFormTags,
    ModalPase,
    ModalDocumentos,
    BFormFile,
    // BForm,
    // BInputGroup,
    // BInputGroupPrepend,
  },
  directives: {
    'b-popover': VBPopover,
    // 'b-tooltip': VBTooltip,
    heightFade,
    Ripple,
  },
  props: {
    playerSelected: Object,
    playerAuxiliar: Object,
    categoriaSeleccionada: Object,
    posiciones: Array,
    tiposAdicional: Array,
    listCategorias: Array,
    // campeonatoAbosoluto: Object,
  },
  setup(props, { emit }) {
    // console.log('setup modal')
    // console.log(props.isAbierto)
    const croppaFoto = ref({})
    const userEmail = ref('')
    const croppaCedula = ref({})
    const listPlayers = ref([])
    const filtered = ref([])
    const filesFotos = ref([])
    const filesDocumentos = ref([])
    const listEquiposTransferir = ref([])
    const { getApi, postApi } = apiCall()
    const selectedRadio = ref('active')
    const disabledInputs = ref(false)
    // eslint-disable-next-line
    const disabledObservacion = ref(USER().rol === ROLES.CLUB ? true : false)
    const isPassportOther = ref(false)
    const hasError = ref(false)
    const showLoading = ref(false)
    const showLoadingProcesar = ref(false)
    const showLoadingProcesarDocumentos = ref(false)
    const messageError = ref('')
    const variante = ref('danger')
    const refCi = ref()
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const popoverShow = ref(true)
    const checkClasificado = ref(false)
    const { postApiFormData } = apiCall()
    // const observ = ref(['la fotografia ha sido actualizada', 'dso'])
    const optionsEstadoJugador = ref([
      {
        text: 'Inscrito',
        value: 'inscrito',
        disabled: false,
        selected: true,
      },
      { text: 'Revisado', value: 'revisado', disabled: false },
      { text: 'Calificado', value: 'calificado', disabled: false },
    ])
    // const observaciones = computed(() => {
    //   const arrayReturn = []
    //   if (props.playerSelected.observaciones !== undefined) {
    //     props.playerSelected.observaciones.forEach(element => {
    //       arrayReturn.push(element.mensaje)
    //     })
    //   }
    //   return arrayReturn
    // })
    function openRespaldos() {
      store.commit('someVariables/UPDATE_SHOW_DOCUMENTOS', true)
    }
    const getProxy = url =>
      // eslint-disable-next-line
      `${URL_PROXY}${encodeURIComponent(url)}`
    const actionPlayer = computed(() => {
      let texto = 'Guardar'
      if (
        store.getters['someVariables/getActionPlayer'] === INSERT_DATA_PLAYER
      ) {
        texto = 'Guardar'
      } else if (
        store.getters['someVariables/getActionPlayer'] ===
        INSERT_DATA_HISTORY_PLAYER
      ) {
        texto = 'Agregar'
      } else if (
        store.getters['someVariables/getActionPlayer'] === UPDATE_DATA_PLAYER
      ) {
        texto = 'Actualizar'
      }
      return texto
    })
    const disabledObj = computed(() => {
      const objDisabled = {
        buscador: false,
        nombres: false,
        apellidos: false,
        fechaNacimiento: false,
        direccion: false,
        telefono: false,
        email: false,
        foto: true,
      }
      const action = store.getters['someVariables/getActionPlayer']
      if (action === INSERT_DATA_PLAYER) {
        objDisabled.buscador = false
        objDisabled.nombres = false
        objDisabled.apellidos = false
        objDisabled.fechaNacimiento = false
      } else if (action === INSERT_DATA_HISTORY_PLAYER) {
        objDisabled.nombres = true
        objDisabled.apellidos = true
        objDisabled.fechaNacimiento = true
        objDisabled.foto = false
      } else if (action === UPDATE_DATA_PLAYER) {
        if (props.playerSelected.nuevo === 'n') {
          objDisabled.buscador = true
          objDisabled.nombres = true
          objDisabled.apellidos = true
          objDisabled.fechaNacimiento = true
          objDisabled.foto = false
        }
        if (
          USER().editar_player &&
          (USER().rol === ROLES.SUPER ||
            USER().rol === ROLES.ADMIN ||
            USER().rol === ROLES.CALIFICACION)
        ) {
          objDisabled.buscador = false
          objDisabled.nombres = false
          objDisabled.apellidos = false
          objDisabled.fechaNacimiento = false
          objDisabled.foto = true
        }
        if (
          props.playerSelected.permiso_editar_personal &&
          USER().rol === ROLES.CLUB
        ) {
          objDisabled.buscador = true
          objDisabled.nombres = false
          objDisabled.apellidos = false
          objDisabled.fechaNacimiento = false
          objDisabled.foto = true
        }
        if (props.playerSelected.tipoJugador === 'CLASIFICADO') {
          checkClasificado.value = true
        } else {
          checkClasificado.value = false
        }
      }
      // console.log('aqui')
      // console.log(action, props.playerSelected.nuevo)
      // if (props.playerSelected.nuevo === 'n') {
      //   objDisabled.buscador = true
      //   objDisabled.nombres = true
      //   objDisabled.apellidos = true
      //   objDisabled.fechaNacimiento = true
      // }
      // let disabled = false
      // if (props.playerSelected.nuevo === 'n') {
      //   disabled = true
      // }
      // console.log(disabled)
      return objDisabled
    })
    const optionsEstado = computed(() => {
      if (USER().rol === ROLES.CLUB) {
        if (props.playerSelected.estado_jug === ESTADO_JUGADOR.INSCRITO) {
          optionsEstadoJugador.value[0].selected = true
          optionsEstadoJugador.value[0].disabled = false
          optionsEstadoJugador.value[1].disabled = true
          optionsEstadoJugador.value[2].disabled = true
        } else if (
          props.playerSelected.estado_jug === ESTADO_JUGADOR.REVISADO
        ) {
          optionsEstadoJugador.value[1].selected = true
          optionsEstadoJugador.value[1].disabled = false
          optionsEstadoJugador.value[0].disabled = true
          optionsEstadoJugador.value[2].disabled = true
        } else if (
          props.playerSelected.estado_jug === ESTADO_JUGADOR.CALIFICADO
        ) {
          optionsEstadoJugador.value[2].selected = true
          optionsEstadoJugador.value[2].disabled = false
          optionsEstadoJugador.value[0].disabled = true
          optionsEstadoJugador.value[1].disabled = true
        }
      }
      if (
        USER().rol === ROLES.SUPER ||
        USER().rol === ROLES.ADMIN ||
        USER().rol === ROLES.CALIFICACION
      ) {
        if (props.playerSelected.estado_jug === ESTADO_JUGADOR.CALIFICADO) {
          props.playerSelected.permiso_editar_personal = false
        }
      }
      // else if (
      //   USER().rol === ROLES.ADMIN ||
      //   USER().rol === ROLES.SUPER ||
      //   USER().rol === ROLES.CALIFICACION
      // ) {
      //   if (props.playerSelected.estado_jug === ESTADO_JUGADOR.CALIFICADO) {
      //     // observacionesAuxiliar = props.playerSelected.observaciones
      //     props.playerSelected.observaciones = []
      //   }
      // }
      return optionsEstadoJugador.value
    })

    // watchEffect(() => croppaFoto.value.refresh())
    // watch(fotoHistorial, (despues, antes) => {
    //   console.log(`watchRefAnt: ${antes}`)
    //   props.playerSelected.foto_jug = despues
    //   console.log(`watchRefDes: ${despues}`)
    //   croppaFoto.value.refresh()
    // })
    // const showNewPlayer = ref(true)
    // onUpdated(() => {
    //   // console.log(`updated() val: `)
    //   this.croppaFoto.value.refresh()
    // })
    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    async function updateFacialIdV3(idJugador, embending, message) {
      const path = 'ApiInscripciones/updateFacialIdv3'
      const data = {
        id_jugador: idJugador,
        embed: embending,
        movimiento: `Actualiza Facial ID de jugador con C.I ${props.playerSelected.ci_pasaporte}, ${message}`,
        id_user: USER().id_usuario,
        id_torneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      }
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        showMessageAlert('success', `Exitos ${message}`)
        emit('updateFacial')
      }
    }

    async function procesarImagenes() {
      // console.log(filesFotos.value)
      if (filesFotos.value.length <= 1) {
        showMessageAlert('danger', 'debes seleccionar al menos 2 fotografías')
        return
      }
      showLoadingProcesar.value = true

      const path = URL_PROCESO_IMAGENES
      const archivo = new FormData()
      if (filesFotos.value != null) {
        filesFotos.value.forEach(file => {
          archivo.append('images[]', file) // Usamos "file[]" para múltiples archivos
        })
      }
      // console.log(dataNoticia)
      // const path = 'ApiInscripciones/guardarImagenes'
      // const response = await postApiFormData(URL, path, archivo)
      const response = await postApiFormData(path, '', archivo)
      if (response.flag === 'si') {
        updateFacialIdV3(
          props.playerSelected.id_jugador,
          response.embending,
          // eslint-disable-next-line
          response.message,
        )
      }
      showLoadingProcesar.value = false
      // console.log(response)
    }

    async function procesarDocumentos() {
      // console.log(filesDocumentos.value)
      const path = 'ApiInscripciones/updateDocumentosJugador'
      if (filesDocumentos.value.length <= 0) {
        showMessageAlert('danger', 'debes seleccionar al menos 1 documento')
        return
      }
      showLoadingProcesarDocumentos.value = true
      const archivo = new FormData()
      if (filesDocumentos.value != null) {
        filesDocumentos.value.forEach(file => {
          archivo.append('file[]', file) // Usamos "file[]" para múltiples archivos
        })
      }
      archivo.append('id_equipo', props.playerSelected.id_equipo)
      archivo.append('id_jugador', props.playerSelected.id_jugador)
      // console.log(dataNoticia)
      // const path = 'ApiInscripciones/guardarImagenes'
      // const response = await postApiFormData(URL, path, archivo)
      const response = await postApiFormData(URL, path, archivo)
      if (response && response.flag === 'si') {
        const archivosSubidos = response.archivos_jugador || []
        props.playerSelected.archivos_jugador.push(...archivosSubidos)
        showMessageAlert('success', 'Documentos subidos correctamente')
        filesDocumentos.value = []
      }
      showLoadingProcesarDocumentos.value = false
      // console.log(response)
    }
    function automatizeObservacion(newValue) {
      const size = newValue.length
      if (
        size > 0 &&
        props.playerSelected.estado_jug === ESTADO_JUGADOR.REVISADO
      ) {
        // console.log('mayor que cero')
        props.playerSelected.estado_jug = 'revisado'
      }
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function formatter(value) {
      return value.toUpperCase()
    }
    function setCroppaRefresh() {
      setTimeout(() => {
        croppaFoto.value.refresh()
        croppaCedula.value.refresh()
      }, 100)
    }

    function initPlayer() {
      props.playerSelected.nombres = ''
      props.playerSelected.apellidos = ''
      props.playerSelected.fecha_nac = ''
      props.playerSelected.num_camiseta = ''
      props.playerSelected.direccion = ''
      props.playerSelected.telefono = ''
      props.playerSelected.email = ''
      props.playerSelected.posicion = null
      props.playerSelected.id_posicion = ''
      props.playerSelected.foto_jug = ''
      props.playerSelected.foto_cedula = ''
      props.playerSelected.id_jugador = null
      props.playerSelected.vacuna = null
      props.playerSelected.estado_jug = ESTADO_JUGADOR.INSCRITO
      props.playerSelected.edad = 0
      disabledInputs.value = false
      store.commit('someVariables/UPDATE_ACTION_PLAYER', INSERT_DATA_PLAYER)
      setCroppaRefresh()
    }
    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      // emit('recargar', props.playerSelected.id_equipo)
      hasError.value = false
      listPlayers.value = []
      showLoading.value = false
      countDownChanged(0)
      // initPlayer()
      //       this.$emit('closeModal', false)
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_NEW_PLAYER', false)
      showLoading.value = false
    }
    function calculateTypePlayer(dataCategoria) {
      // console.log(dataCategoria)
      let isJuvenilDos = false
      if (dataCategoria.tieneJuvenil === 's') {
        if (dataCategoria.validarPorAnios === 's') {
          const isJuvenil = moment(props.playerSelected.fecha_nac).isBetween(
            dataCategoria.fechaMinJuvenil,
            dataCategoria.fechaMaxJuvenil,
            undefined,
            // eslint-disable-next-line
            '[]',
          )
          if (dataCategoria.tieneJuvenilDos === '1') {
            isJuvenilDos = moment(
              props.playerSelected.fecha_nac,
            ).isSameOrBefore(
              dataCategoria.fechaMinJuvenilDos,
              undefined,
              // eslint-disable-next-line
              '[]',
            )
          }
          // console.log(isJuvenilDos, dataCategoria.fechaMinJuvenilDos)
          props.playerSelected.tipoJugador =
            isJuvenil || isJuvenilDos ? 'JUVENIL' : 'NOVATO'
          checkClasificado.value = false
        } else {
          const [
            anioInicial,
            mesInicial,
            anioFinal,
            mesFinal,
          ] = dataCategoria.limitesAnios
          const diffDuration = moment.duration(
            // eslint-disable-next-line
            moment().diff(props.playerSelected.fecha_nac),
          )
          const anio = diffDuration.years()
          const mes = diffDuration.months()

          if (anio >= Number(anioInicial) && anio <= Number(anioFinal)) {
            if (mes >= Number(mesInicial) && mes <= Number(mesFinal)) {
              props.playerSelected.tipoJugador = 'JUVENIL'
            } else {
              props.playerSelected.tipoJugador = 'NOVATO'
            }
          } else {
            props.playerSelected.tipoJugador = 'NOVATO'
          }
        }
      } else {
        props.playerSelected.tipoJugador = 'NOVATO'
      }
    }
    watch(checkClasificado, despues => {
      // console.log(despues)
      if (despues) {
        props.playerSelected.tipoJugador = 'CLASIFICADO'
      } else {
        calculateTypePlayer(props.playerSelected.dataCategoria)
      }
    })
    function calculateAge(date) {
      // const years = moment().diff(date, 'YYYY-MM-DD')
      const diffDuration = moment.duration(moment().diff(date))
      props.playerSelected.edad = `${diffDuration.years()} años, ${diffDuration.months()} meses, ${diffDuration.days()} dias`
      calculateTypePlayer(props.playerSelected.dataCategoria)
    }
    // const showNewPlayer = computed(() => props.isOpen)
    async function searchPlayer(value) {
      // console.log(value)
      // console.log(props.playerSelected)
      const action = store.getters['someVariables/getActionPlayer']
      if (action === INSERT_DATA_PLAYER) {
        if (value.length) {
          const path = `ApiInscripciones/getJugadoresCedula/${value}/${props.playerSelected.id_disciplina}`
          const data = await getApi(URL, path)
          // this.listPlayers.value = data.jugadores
          if (data.flag === 'si') {
            listPlayers.value = []
            data.jugadores.forEach(element => {
              const obj = {
                label: `${element.ci_pasaporte}`,
                value: element.id_jugador,
                apellidos: element.apellidos,
                nombres: element.nombres,
                direccion: element.direccion,
                email: element.email,
                telefono: element.telefono,
                fecha_nac: element.fecha_nac,
                nuevo: element.nuevo,
                edad: element.edad,
                posicion: {
                  label: element.posicion,
                  value: element.id_posicion,
                },
                id_posicion: element.id_posicion,
                foto_jug: element.foto_jug,
                foto_cedula: element.foto_cedula,
                id_jugador: element.id_jugador || null,
                id_equipo: props.playerSelected.id_equipo,
              }
              listPlayers.value.push(obj)
            })
          } else {
            // props.playerSelected.ci_pasaporte = value
            initPlayer()
          }
        } else {
          // this.listCI = []
          // this.deHistorial=false;
          // console.log("ssss");
        }
      }
      //  trigger a mutation, or dispatch an action
    }
    function desabilitarEnHistorial(obj) {
      obj.nombres = true
      obj.apellidos = true
      obj.direccion = true
      obj.telefono = true
      obj.email = true
      obj.fechaNacimiento = true
    }

    function setearDatosDeHistorial(item) {
      props.playerSelected.id_jugador = item.id_jugador
      props.playerSelected.nombres = item.nombres
      props.playerSelected.apellidos = item.apellidos
      props.playerSelected.email = item.email
      props.playerSelected.fecha_nac = item.fecha_nac
      props.playerSelected.telefono = item.telefono
      props.playerSelected.direccion = item.direccion
      props.playerSelected.posicion = item.posicion
      props.playerSelected.rol = USER().rol
      props.playerSelected.foto_jug = item.foto_jug
      props.playerSelected.foto_cedula = item.foto_cedula
      props.playerSelected.edad = item.edad
      props.playerSelected.nuevo = item.nuevo
      props.playerSelected.estado_jug = 'inscrito'
      disabledInputs.value = true
      calculateTypePlayer(props.playerSelected.dataCategoria)
      desabilitarEnHistorial(disabledObj.value)
      setCroppaRefresh()
    }
    async function getListEquiposUltimosJugo(idJugador) {
      const path = `ApiInscripciones/getEquiposUltimoJugo/${idJugador}`
      const data = await getApi(URL, path)
      listEquiposTransferir.value = data
    }
    function changePlayer(item) {
      let action = store.getters['someVariables/getActionPlayer']
      // console.log(item)
      if (item !== null) {
        if (action !== UPDATE_DATA_PLAYER) {
          if (item.id_jugador === undefined) {
            // console.log('accion insertar jugador')
            action = INSERT_DATA_PLAYER
          } else {
            // console.log('accion insertar jugador de historial')
            action = INSERT_DATA_HISTORY_PLAYER
            setearDatosDeHistorial(item)
            // getListEquiposUltimosJugo(item.id_jugador)
          }
        }
        store.commit(
          'someVariables/UPDATE_ACTION_PLAYER',
          // eslint-disable-next-line
          action,
        )
        // console.log(action)
      } else {
        initPlayer()
      }
    }
    function focusInput(id, error) {
      document.getElementById(id).focus()
      messageError.value = error
    }
    function hasErrorForm() {
      // console.log(refCi)
      let error = false
      if (
        props.playerSelected.ci_pasaporte === '' ||
        props.playerSelected.ci_pasaporte === null ||
        props.playerSelected.ci_pasaporte === undefined
      ) {
        focusInput('input-ci-pasaporte', 'C.I o Passaporte es requerido')
        error = true
      } else if (
        props.playerSelected.num_camiseta === '' ||
        props.playerSelected.num_camiseta === null ||
        props.playerSelected.num_camiseta === undefined ||
        props.playerSelected.num_camiseta === 0
      ) {
        focusInput('floating-camiseta', 'Número camiseta es requerido')
        error = true
      } else if (
        props.playerSelected.nombres === '' ||
        props.playerSelected.nombres === null ||
        props.playerSelected.nombres === undefined
      ) {
        focusInput('floating-nombres', 'Nombres es requerido')
        error = true
      } else if (
        props.playerSelected.apellidos === '' ||
        props.playerSelected.apellidos === null ||
        props.playerSelected.apellidos === undefined
      ) {
        focusInput('floating-apellidos', 'Apellidos es requerido')
        error = true
      } else if (
        props.playerSelected.fecha_nac === '' ||
        props.playerSelected.fecha_nac === null ||
        props.playerSelected.fecha_nac === undefined
      ) {
        focusInput('floating-nacimiento', 'Fecha de nacimiento es requerido')
        error = true
        // } else if (
        //   props.playerSelected.posicion === '' ||
        //   props.playerSelected.posicion === null ||
        //   props.playerSelected.posicion === undefined
        // ) {
        //   focusInput('input-posicion', 'Posición del jugador es requerido')
        //   error = true
      } else {
        error = false
      }
      return error
    }
    function getPicturePlayer(croppa) {
      let fotografia = ''
      if (croppa.value.chosenFile == null) {
        fotografia = ''
      } else {
        const fotografiaBase64 = croppa.value.generateDataUrl(
          'image/jpeg',
          // eslint-disable-next-line
          0.5,
        )
        fotografia = fotografiaBase64
      }
      return fotografia
    }

    function isNullPosition(position) {
      let pos = ''
      if (position !== null) {
        pos = position.value
      } else {
        pos = ''
      }
      return pos
    }
    function transformarObservacionesToString(observaciones) {
      let strinConversion = ''
      // console.log(observaciones)
      observaciones.forEach(element => {
        // if (
        //   element !== 'La fotografía ha sido actualizada' &&
        //   element !== 'La cédula ha sido actualizada'
        // ) {
        strinConversion += `${element};`
        // }
      })
      // console.log(strinConversion)
      return strinConversion
    }
    function getStringChanges() {
      // let has = false
      // console.log(props.playerSelected)

      let stringFinal = ''
      if (
        props.playerAuxiliar.ci_pasaporte !== props.playerSelected.ci_pasaporte
      ) {
        stringFinal += `cambia cedula de ${props.playerAuxiliar.ci_pasaporte} a ${props.playerSelected.ci_pasaporte} `
      }
      if (
        props.playerAuxiliar.num_camiseta !== props.playerSelected.num_camiseta
      ) {
        stringFinal += `cambia #num camiseta de ${props.playerAuxiliar.num_camiseta} a ${props.playerSelected.num_camiseta} `
      }
      if (props.playerAuxiliar.nombres !== props.playerSelected.nombres) {
        stringFinal += `cambia nombres de ${props.playerAuxiliar.nombres} a ${props.playerSelected.nombres} `
      }
      if (props.playerAuxiliar.apellidos !== props.playerSelected.apellidos) {
        stringFinal += `cambia apellidos de ${props.playerAuxiliar.apellidos} a ${props.playerSelected.apellidos} `
      }
      if (props.playerAuxiliar.fecha_nac !== props.playerSelected.fecha_nac) {
        stringFinal += `cambia fecha nacimiento de ${props.playerAuxiliar.fecha_nac} a ${props.playerSelected.fecha_nac} `
      }
      if (
        props.playerAuxiliar.tipoJugador !== props.playerSelected.tipoJugador
      ) {
        stringFinal += `cambia tipo jugador de ${props.playerAuxiliar.tipoJugador} a ${props.playerSelected.tipoJugador} `
      }
      if (
        props.playerAuxiliar.tipo_adicional !==
        props.playerSelected.tipo_adicional_send
      ) {
        stringFinal += `cambia tipo jugador adicional de ${props.playerAuxiliar.tipo_adicional} a ${props.playerSelected.tipo_adicional_send} `
      }
      if (props.playerSelected.fotografia !== '') {
        stringFinal += 'cambia fotografía '
      }
      if (props.playerSelected.fotografia_cedula !== '') {
        stringFinal += 'cambia fotografía cedula'
      }
      if (props.playerAuxiliar.estado_jug !== props.playerSelected.estado_jug) {
        stringFinal += `cambia status jugador de ${props.playerAuxiliar.estado_jug} a ${props.playerSelected.estado_jug} `
      }
      return stringFinal
    }
    // function marcaCalificado() {
    //   let calificado = false
    //   if (
    //     props.playerAuxiliar.estado_jug !== props.playerSelected.estado_jug &&
    //     props.playerSelected.estado_jug === ESTADO_JUGADOR.CALIFICADO
    //   ) {
    //     calificado = true
    //   }
    //   return calificado
    // }
    async function savePlayer() {
      const action = store.getters['someVariables/getActionPlayer']
      hasError.value = hasErrorForm()
      if (!hasError.value) {
        showLoading.value = true
        if (action === INSERT_DATA_PLAYER) {
          const isObject = typeof props.playerSelected.ci_pasaporte === 'object'
          // console.log(isObject)
          if (isObject) {
            props.playerSelected.ci_pasaporte_env =
              props.playerSelected.ci_pasaporte.label
          } else {
            props.playerSelected.ci_pasaporte_env =
              props.playerSelected.ci_pasaporte
          }
          props.playerSelected.id_posicion = isNullPosition(
            // eslint-disable-next-line
            props.playerSelected.posicion,
          )
          props.playerSelected.fotografia = getPicturePlayer(croppaFoto)
          props.playerSelected.fotografia_cedula = getPicturePlayer(
            // eslint-disable-next-line
            croppaCedula,
          )
          props.playerSelected.observaciones_enviar = transformarObservacionesToString(
            // eslint-disable-next-line
            props.playerSelected.observaciones,
          )
          props.playerSelected.rol = USER().rol
          props.playerSelected.tipo_adicional_send =
            props.playerSelected.tipo_adicional.value
          props.playerSelected.id_torneo =
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo
          props.playerSelected.id_categoria =
            props.categoriaSeleccionada.id_categoria
          props.playerSelected.id_campeonato =
            props.categoriaSeleccionada.campeonato.id_campeonato
          // throw 'error'
          // this.openLoadingContained("#" + this.idButtonLogin);
          const path = 'ApiInscripciones/insertJugador'
          props.playerSelected.idUserIngresa = USER().id_usuario
          const response = await postApi(URL, path, props.playerSelected)
          if (response.flag === 'si') {
            showMessageAlert('success', 'JUGADOR agregado exitosamente')
            emit('recargarHistorial', props.playerSelected.id_equipo)
            initPlayer()
            props.playerSelected.ci_pasaporte = null
          } else {
            showMessageAlert('danger', response.mensaje)
          }
          showLoading.value = false
        } else if (action === INSERT_DATA_HISTORY_PLAYER) {
          // console.log(props.playerSelected)
          const isObject = typeof props.playerSelected.posicion === 'object'
          if (isObject) {
            props.playerSelected.id_posicion =
              props.playerSelected.posicion.value
          } else {
            props.playerSelected.id_posicion = null
          }
          // props.playerSelected.posicion = ''
          // props.playerSelected.ci_pasaporte = ''
          props.playerSelected.rol = USER().rol
          props.playerSelected.id_torneo =
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo
          props.playerSelected.id_categoria =
            props.categoriaSeleccionada.id_categoria
          props.playerSelected.id_disciplina =
            props.categoriaSeleccionada.id_disciplina
          props.playerSelected.vieneBusqueda = true
          props.playerSelected.id_campeonato =
            props.categoriaSeleccionada.campeonato.id_campeonato
          // console.log(props.playerSelected.id_campeonato)

          const path = 'ApiInscripciones/addHistorial'
          const response = await postApi(URL, path, props.playerSelected)
          if (response.flag === 'si') {
            emit('recargarHistorial', props.playerSelected.id_equipo)
            showMessageAlert('success', 'JUGADOR agregado exitosamente')
            initPlayer()
            props.playerSelected.ci_pasaporte = null
          } else {
            showMessageAlert('danger', response.mensaje)
          }
          showLoading.value = false
        } else if (action === UPDATE_DATA_PLAYER) {
          props.playerSelected.id_posicion = isNullPosition(
            // eslint-disable-next-line
            props.playerSelected.posicion,
          )
          if (
            props.playerSelected.tipo_adicional === undefined ||
            props.playerSelected.tipo_adicional === null ||
            props.playerSelected.tipo_adicional === ''
          ) {
            props.playerSelected.tipo_adicional_send = null
          } else {
            const isObject =
              typeof props.playerSelected.tipo_adicional === 'object'
            if (isObject) {
              props.playerSelected.tipo_adicional_send =
                props.playerSelected.tipo_adicional.value
            } else {
              props.playerSelected.tipo_adicional_send =
                props.playerSelected.tipo_adicional
            }
          }
          props.playerSelected.id_campeonato =
            props.categoriaSeleccionada.campeonato.id_campeonato

          props.playerSelected.fotografia = getPicturePlayer(croppaFoto)
          props.playerSelected.fotografia_cedula = getPicturePlayer(
            // eslint-disable-next-line
            croppaCedula,
          )
          // console.log(props.playerSelected.fotografia)
          // console.log(props.playerSelected.fotografia_cedula)
          let observ = ''
          if (props.playerSelected.fotografia !== '') {
            observ += 'Fotografía pendiente de revisión;'
          }
          if (props.playerSelected.fotografia_cedula !== '') {
            observ += 'Cédula pendiente de revisión;'
          }
          props.playerSelected.observaciones_enviar = transformarObservacionesToString(
            // eslint-disable-next-line
            props.playerSelected.observaciones,
          )
          props.playerSelected.observaciones_enviar += observ
          // console.log(props.playerSelected.observaciones_enviar)
          props.playerSelected.rol = USER().rol
          if (props.playerSelected.estado_jug === ESTADO_JUGADOR.CALIFICADO) {
            props.playerSelected.observaciones_enviar = ''
          }

          const infoInicial = `Club ${props.playerSelected.equipo} ${props.playerSelected.disciplina} ${props.playerSelected.categoria} C.I: ${props.playerSelected.ci_pasaporte} # ${props.playerSelected.num_camiseta}`
          const dataMovimientoString = getStringChanges()
          const tieneCambios = dataMovimientoString === '' ? 'no' : 'si'
          props.playerSelected.hasChanges = tieneCambios
          props.playerSelected.dataMovimiento = `${infoInicial} ${dataMovimientoString}`
          // if (marcaCalificado()) {
          //   props.playerSelected.dataStatusPlayer = `${infoInicial} cambia status a CALIFICADO `
          // } else {
          //   props.playerSelected.dataStatusPlayer = ''
          // }
          props.playerSelected.dataStatusPlayer = ''
          props.playerSelected.idTorneo =
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo

          const path = 'ApiInscripciones/actualizarJugador'
          props.playerSelected.idUserIngresa = USER().id_usuario
          props.playerSelected.editar_player = USER().editar_player
          if (
            props.playerAuxiliar.estado_jug === ESTADO_JUGADOR.CALIFICADO &&
            props.playerSelected.estado_jug === ESTADO_JUGADOR.CALIFICADO
          ) {
            // console.log('aqui')
            props.playerSelected.hasChanges = 'si'
            props.playerSelected.dataMovimiento = `${infoInicial} ${dataMovimientoString} , es RECALIFICADO`
            emit('showRecalificacion', props.playerSelected)
          } else {
            const response = await postApi(URL, path, props.playerSelected)
            if (response.flag === 'si') {
              emit('recargar', props.playerSelected.id_equipo)
              initPlayer()
              store.commit('someVariables/UPDATE_SHOW_NEW_PLAYER', false)
            } else {
              showMessageAlert('danger', response.mensaje)
            }
          }

          showLoading.value = false
        }
      } else {
        variante.value = 'danger'
        dismissCountDown.value = dismissSecs.value
      }
      // console.log(hasError.value)
      // console.log()
    }
    function initDePase() {
      emit('recargarHistorial', props.playerSelected.id_equipo)
      initPlayer()
      props.playerSelected.ci_pasaporte = null
    }
    function showModalPase() {
      getListEquiposUltimosJugo(props.playerSelected.id_jugador)
      store.commit('someVariables/UPDATE_SHOW_PASE_MODAL', true)
    }
    return {
      userEmail,
      croppaFoto,
      croppaCedula,
      listPlayers,
      searchPlayer,
      filtered,
      changePlayer,
      initPlayer,
      selectedRadio,
      optionsEstadoJugador,
      disabledInputs,
      isPassportOther,
      savePlayer,
      hasErrorForm,
      hasError,
      messageError,
      refCi,
      showLoading,
      variante,
      resetModal,
      countDownChanged,
      dismissCountDown,
      dismissSecs,
      formatter,
      popoverShow,
      calculateAge,
      calculateTypePlayer,
      // defineIsClasificado,
      checkClasificado,
      ROLES,
      USER,
      ESTADO_JUGADOR,
      optionsEstado,
      disabledObservacion,
      onlyClose,
      disabledObj,
      automatizeObservacion,
      UPDATE_DATA_PLAYER,
      showModalPase,
      getListEquiposUltimosJugo,
      listEquiposTransferir,
      initDePase,
      actionPlayer,
      procesarImagenes,
      filesFotos,
      filesDocumentos,
      showLoadingProcesar,
      showLoadingProcesarDocumentos,
      INSERT_DATA_HISTORY_PLAYER,
      getProxy,
      procesarDocumentos,
      openRespaldos,
      // observ,
      // observaciones,
      // holaMundo,
      // hola,
      // fotoHistorial,
    }
  },
}
</script>
<style>
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
.inscrito {
  margin: 0px;
  background: #e6e5e2;
  border-radius: 5px;
  padding-left: 5px;
  font-size: 12px;
}
.calificado {
  margin-top: 10px;
  background: #84ef96;
  border-radius: 5px;
  padding-left: 5px;
  font-size: 12px;
}
.recalificado {
  margin-top: 10px;
  background: #cbebd1;
  border-radius: 5px;
  padding-left: 5px;
  font-size: 12px;
}
</style>
